<div class="content" [@routerAnimation]="getRouteAnimation(router)">
    <router-outlet #router="outlet"></router-outlet>
</div>